import * as React from "react";
const SvgChevronDoubleDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m49 43-7 7-7-7m14-8-7 7-7-7"
    />
  </svg>
);
export default SvgChevronDoubleDown;
